import React, { useState } from 'react';
import './FAQ.scss';

const faqs = [
  {
    question: "What is 311 used for?",
    answer: "311 is a non-emergency service line for city services like sanitation, street repair, noise complaints, and more."
  },
  {
    question: "Can I request services through 311?",
    answer: "Yes, you can report issues or request services like pothole repairs, trash pickup, or animal control."
  },
  {
    question: "Is 311 available 24/7?",
    answer: "Most 311 services operate 24/7, but response times may vary depending on the city."
  },
  {
    question: "Is 311 free to call?",
    answer: "Yes, 311 is a free service and can be called from landlines and mobile phones."
  },
  {
    question: "Can I use 311 online?",
    answer: "Yes, many cities provide 311 services via websites and mobile apps for reporting and tracking issues."
  }
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div
    className="signup-content2 "
    style={{
      paddingLeft: "2%",
      paddingRight: "2%",
      paddingTop: "1%",
      height: "100vh",
    }}>
{/* <div
className="card  mb-3  p-2"
style={{
  background: "rgb(78 155 1 / 69%)",
  textAlign: "left",
}}
>
<h5 style={{ color: "whitesmoke", marginBottom: "0px" }}>
  {" "}
  FAQ{" "}
</h5>
</div> */}
    <div className="faq-container">
      <h2 className="faq-title">311 Service – Frequently Asked Questions</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`} onClick={() => toggleFAQ(index)}>
            <div className="faq-question">
              {faq.question}
              <span className="toggle-icon">{activeIndex === index ? '−' : '+'}</span>
            </div>
            {activeIndex === index && <div className="faq-answer">{faq.answer}</div>}
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default FAQ;
